import React, { PureComponent } from 'react';
import ym from 'react-yandex-metrika';
import { connect } from 'react-redux';
import { parse, stringify } from 'query-string';
import { string, func, object } from 'prop-types';
import { webmaster } from '../../../services/ApiService';
import { Cookies, redirectToOffice, shouldDisableRecaptcha } from '../../../utils/utils';
import { startSetAuthSettings } from '../../../actions/app';

class SocialButtons extends PureComponent {
  static propTypes = {
    type: string,
    setLoadingState: func,
    modalProps: object,
  };

  static defaultProps = {
    modalProps: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      requestType: null,
      isLoading: false,
      socials: props.socials,
      error: null,
      recaptchaToken: '',
    };
  }

  componentWillReceiveProps({ socials }) {
    this.setState(() => ({ socials }));
  }

  componentDidMount() {
    if (shouldDisableRecaptcha()) {
      this.verifyCallback();
    }
  }

  getResponseFromLocation = () => {
    return new Promise((resolve, reject) => {
      const { hash, search } = window.location;
      let params = parse(search.replace(/&quot;/g, '"'));

      if (!params.code && !params.error && hash !== '#_=_') {
        params = parse(hash);
      }

      if (!params.state || !this.getProvider(params.state)) {
        resolve(null);
      }

      if (params.access_token || params.code) {
        const token = params.access_token || params.code;
        const provider = this.getProvider(params.state);
        const redirect_uri = this.getRedirectUri();

        resolve({ token, provider, redirect_uri });
      } else if (params.error && params.error_description) {
        reject({
          error: {
            type: params.error,
            message: params.error_description,
          },
        });
      }

      resolve(null);
    });
  };

  getProvider(state) {
    try {
      const { provider } = JSON.parse(state);
      return provider;
    } catch (e) {
      this.handleError({
        type: 'Wrong provider',
        message: 'Провайдер указан не верно',
      });
      return null;
    }
  }

  getRedirectUri() {
    const { origin } = window.location;
    return `${origin}/publisher/sign_in`;
  }

  authorization = (provider) => {
    const { appId } = this.state.socials[provider];
    const redirect_uri = this.getRedirectUri();
    const state = JSON.stringify({ provider });

    this.setState(
      () => ({ isLoading: true, error: null }),
      () => {
        window.location.href = this.getAuthorizationUrl(appId, provider, redirect_uri, state);
      },
    );
  };

  getAuthorizationUrl(appId, provider, redirect_uri, state) {
    let params;

    switch (provider) {
      // case 'google':
      //   params = stringify({
      //     client_id: appId,
      //     response_type: 'token',
      //     scope: 'email openid profile',
      //     redirect_uri,
      //     state,
      //   });

      //   return `https://accounts.google.com/o/oauth2/auth?${params}`;

      case 'facebook':
        params = stringify({
          client_id: appId,
          response_type: 'token',
          redirect_uri,
          scope: 'email',
          state,
        });

        return `https://www.facebook.com/v3.1/dialog/oauth?${params}`;

      case 'vk':
        params = stringify({
          client_id: appId,
          display: 'page',
          redirect_uri,
          response_type: 'code',
          scope: 'email',
          v: '5.85',
          state,
        });

        return `https://oauth.vk.com/authorize?${params}`;
    }
  }

  handleError(error = {}) {
    this.setState(() => ({ error: error.message, loading: false }));
  }

  verifyCallback = (recaptchaToken) => {
    const isRecaptchaDisabled = shouldDisableRecaptcha();
    this.setState(() => ({ recaptchaToken: isRecaptchaDisabled ? '' : recaptchaToken }));

    this.getResponseFromLocation()
      .then((response) => {
        if (response === null) {
          return;
        }

        const { provider, token: accessToken, redirect_uri } = response;

        this.setState(() => ({ isLoading: true, requestType: provider }));

        const redirectUrl =
          localStorage.getItem('redirect_url') || Cookies.get('redirect_url') || undefined;

        const tokenData = {
          accessToken,
          redirect_uri,
          redirectUrl,
          ...(isRecaptchaDisabled ? {} : { recaptchaToken }),
        };

        webmaster
          .loginBySocial(provider, tokenData)
          .then(({ items = {} }) => {
            if (items.auth && items.redirectUrl) {
              // отправка в метрики если кнопки соцсетей работают как регистрация, и условие ниже не будет работать, поскольку type не передается вообще
              // в соответствии с OFFERRUM-1169
              // upd кнопки соц сетей больше не работают на регистрацию - поправили на беке
              if (this.props.type === 'signUp') {
                ym('reachGoal', 'regsuccess', { social: provider });

                if (window.gtag) {
                  window.gtag('event', 'regsuccess', { event_category: 'registration' });
                  window.gtag('event', 'conversion', {
                    send_to: 'AW-710210063/xZGpCP3UvawBEI_k09IC',
                  });
                }
              }

              redirectToOffice(items.redirectUrl, 100);
            }
          })
          .catch(({ response = {} }) => {
            this.setState(() => ({ isLoading: false }));

            if (response.data && response.data.error) {
              const { message: error } = response.data.error;
              this.handleError(error);
            }
          });
      })
      .catch(({ error }) => {
        this.handleError(error);
      });
  };

  render() {
    const { reacaptcha_sitekey, view: View } = this.props;
    const { requestType, isLoading, socials, error } = this.state;
    const data = {
      requestType,
      isLoading,
      socials,
      error,
      reacaptcha_sitekey,
      isRecaptchaEnabled: !shouldDisableRecaptcha(),
    };

    return socials ? (
      <View verifyCallback={this.verifyCallback} authorization={this.authorization} {...data} />
    ) : null;
  }
}

const mapStateToProps = ({ modals: { modalProps }, app }) => ({
  modalProps,
  reacaptcha_sitekey: app.authSettings.recaptcha,
});

const mapDispatchToProps = (dispatch) => ({
  startSetAuthSettings: () => dispatch(startSetAuthSettings()),
});

export default connect(mapStateToProps)(SocialButtons);
